import { render, staticRenderFns } from "./preview-payment.vue?vue&type=template&id=0b4d730c"
import script from "./preview-payment.vue?vue&type=script&lang=js"
export * from "./preview-payment.vue?vue&type=script&lang=js"
import style0 from "./preview-payment.vue?vue&type=style&index=0&id=0b4d730c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports